module.exports = "<div class=\"vrm-dropdown {{customClass}}\" ng-transclude></div>\n";